import Vue from 'vue';
import Vuex from 'vuex';

import Public from 'store/modules/public';
import MyTeam from 'store/modules/my-team';
import Persons from 'store/modules/persons';
import Instance from 'store/modules/instance';
import Personal from 'store/modules/personal';
import Programs from 'store/modules/programs';
import Settings from 'store/modules/settings';
import StuffToDo from 'store/modules/stuff-to-do';
import Invitations from 'store/modules/invitations';
import StuffToEat from 'store/modules/stuff-to-eat';
import Authentication from 'store/modules/authentication';
import SystemAdministration from 'store/modules/system-administration';
import Notices from 'store/modules/notices';
import Dashboard from 'store/modules/dashboard';
import Workspace from 'store/modules/workspace';

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {},
  getters: {},
  modules: {
    MyTeam,
    Public,
    Persons,
    Instance,
    Personal,
    Programs,
    Settings,
    StuffToDo,
    StuffToEat,
    Invitations,
    Authentication,
    SystemAdministration,
    Notices,
    Dashboard,
    Workspace,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js